var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "组织架构",
      "prop": "organize_ids"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #DCDFE6",
      "width": "95%",
      "border-radius": "5px",
      "padding-left": "5%"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$globals.group_name + "/" + _vm.ruleForm.organize_name) + "\n\t\t\t")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "组织架构",
      "prop": "organize_ids"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.ruleForm.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "organize_ids", $$v)
      },
      expression: "ruleForm.organize_ids"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "岗位",
      "prop": "post_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择岗位",
      "multiple": "",
      "collapse-tags": "",
      "filterable": ""
    },
    model: {
      value: (_vm.ruleForm.postId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "postId", $$v)
      },
      expression: "ruleForm.postId"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "性别",
      "prop": "spare5"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择性别"
    },
    model: {
      value: (_vm.ruleForm.spare5),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "spare5", $$v)
      },
      expression: "ruleForm.spare5"
    }
  }, _vm._l((_vm.spare), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.data,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "保费金额",
      "prop": "insurance_price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入保费金额"
    },
    model: {
      value: (_vm.ruleForm.insurance_price),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "insurance_price", $$v)
      },
      expression: "ruleForm.insurance_price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "年龄",
      "prop": "age"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择年龄",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.age),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "age", $$v)
      },
      expression: "ruleForm.age"
    }
  }, _vm._l((_vm.ageList), function(age) {
    return _c('el-option', {
      key: age.id,
      attrs: {
        "label": age.data,
        "value": age.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82071f30","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/GzxbfGl/gzxbfgl_add.vue
// module id = null
// module chunks = 